import React, { useState, useEffect } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Dialog from '~/Common-Objects/UI/Dialog'
import Icons from '~/Common-Objects/UI/Icons/index'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import i18n from '~/i18n'

export default function OptimisedSendingPopup({ submitFeedback = () => {} }) {
    return (
        <>
            <Dialog.Root open={true}>
                <Dialog.Portal>
                    <Dialog.Overlay />
                    <Dialog.Content style={{ width: '480px' }}>
                        <div
                            style={{
                                width: 480,
                                height: 240,
                                backgroundImage: `url('https://cdn1.ourmailsender.com/siteContent/assets/upsell/optimisedPopup.png')`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover'
                            }}
                        ></div>
                        <div style={{ padding: '32px' }}>
                            <h4 className='mar-b12'>Smart Sending is now available!</h4>
                            <div className='mar-b12'>
                                Start sending your campaigns at the right time to avoid spam filters and help your
                                emails reach more inboxes.
                            </div>
                            <div className='mar-b8'>✅ No setup needed</div>
                            <div className='mar-b8'>📈 Higher open and click rates</div>
                            <div className='mar-b12'>🎯 Smarter sending, better engagement</div>
                            <div className='mar-b32'>
                                Available on all Starter plans and above.{' '}
                                <a
                                    href='https://transpond.io/support/deliverability-and-compliance/smart-sending'
                                    target='_blank'
                                >
                                    Learn more
                                </a>
                            </div>

                            <div style={{ display: 'flex' }}>
                                <Button
                                    iconRight={<Icons icon='arrowRight' />}
                                    className='button-primary mar-r10'
                                    text='Create Campaign'
                                    onClick={() => {
                                        submitFeedback(true)
                                    }}
                                />
                                <Button
                                    className='button-lightGrey'
                                    text='Maybe later'
                                    onClick={() => {
                                        submitFeedback(false)
                                    }}
                                />
                            </div>
                        </div>
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        </>
    )
}
